import { useEffect, useState } from 'react'

function useGoogleAnalyticsIds() {
  const [googleSessionId, setGoogleSessionId] = useState<Gtag.CustomParams | string>('')
  const [googleClientId, setGoogleClientId] = useState<Gtag.CustomParams | string>('')

  useEffect(() => {
    if (window.gtag) {
      window.gtag('get', process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_TRACKING_ID, 'session_id', (sessionId) => {
        setGoogleSessionId(sessionId)
      })

      window.gtag('get', process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_TRACKING_ID, 'client_id', (clientId) => {
        setGoogleClientId(clientId)
      })
    }
  }, [])

  return { googleClientId, googleSessionId }
}

export default useGoogleAnalyticsIds
